import styled from 'styled-components';
import { forDesktop, forIE, forTablet, forIEandEdge, safari10MinMaxFallBack } from '@westwing/ui-kit/breakPoints';
import { pagePadding } from '../Generic/BoxHelpers';

export const StyleGridWrapper = styled.div`
    padding: 0 10px;
    ${forTablet`
        padding-left: 0;
        padding-right: 0;
    `}
`;

export const ListingPageContentWrapper = styled.div`
    display: grid;
    grid-template:
        'breadcrumbs' min-content
        'main' auto
        'sidebar' auto
        'seotexttop' auto
        'seotextbot' auto
        / 100%;

    ${forDesktop`
        grid-column-gap: 30px;
        ${safari10MinMaxFallBack`
            grid-template:
                'breadcrumbs breadcrumbs' auto
                'sidebar main' auto
                'seotexttop main' auto
                'blank main' auto
                'blank seotextbot' auto
                / minmax(159px, 239px) minmax(710px, 1092px);
        `}
    `}

    ${forIE`
        display: -ms-grid;
        -ms-grid-rows: auto 1fr;
        -ms-grid-columns: minmax(159px, 239px) minmax(710px, 1092px);
    `}
`;

export const ListingPageContainer = styled.div`
    ${pagePadding}
`;

export const SideBar = styled.aside`
    grid-area: sidebar;
    display: none;

    ${forDesktop`
        display: block;
    `}
    ${forIE`
        -ms-grid-row : 2;
        -ms-grid-row-span : 1;
        -ms-grid-column : 1;
        -ms-grid-column-span : 1;
    `}
`;

export const SeoTextTopWrapper = styled.section`
    color: ${({ theme }) => theme.colors.charcoal100};
    grid-area: seotexttop;
    padding: 0 10px;
    ${forDesktop`
        padding: 0;
    `}
    ${forIE`
        -ms-grid-row : 3;
        -ms-grid-row-span : 1;
        -ms-grid-column : 1;
        -ms-grid-column-span : 1;
    `}
`;

export const SeoTextBottomWrapper = styled.section`
    color: ${({ theme }) => theme.colors.charcoal100};
    grid-area: seotextbot;
    padding: 0 10px;
    ${forIE`
        -ms-grid-row : 3;
        -ms-grid-row-span : 1;
        -ms-grid-column : 2;
        -ms-grid-column-span : 1;
    `}
`;

export const MainContent = styled.main`
    grid-area: main;

    ${forIE`
        -ms-grid-row : 2;
        -ms-grid-row-span : 1;
        -ms-grid-column : 2;
        -ms-grid-column-span : 1;
        margin-left: 20px;
    `}
`;

export const BreadCrumbsWrapper = styled.div`
    grid-area: breadcrumbs;
    display: block;
    ${forIEandEdge`
        -ms-grid-row : 1;
        -ms-grid-row-span : 1;
        -ms-grid-column : 1;
        -ms-grid-column-span : 2;
    `}
`;
